import {default as BaseLog} from './base_log';
import {LogType} from "./base_log";

export default class VIPStat extends BaseLog {

    updateCommon(common) {
        Object.assign(this.common, common);
    }

    /**
     * @Desc   record toast log
     * @Params params log message
     * @Return
     */
    toast(params) {
        this.save({
            lt: LogType.toast,
            ...params,
        });
    }

    /**
     * @Desc   record error log
     * @Params params log message
     * @Return
     */
    error(params) {
        this.save({
            lt: LogType.error,
            ...params,
        });
    }

    /**
     * @Desc   record event log
     * @Params params log message
     * @Return
     */
    event(params) {
        this.save({
            lt: LogType.event,
            ...params,
        });
    }

    /**
     * @Desc   record pageView log
     * @Params params log message
     * @Return
     */
    pageview(params) {
        this.save({
            lt: LogType.pageView,
            ...params,
        });
    }

    /**
     * @Desc   record network log
     * @Params params log message
     * @Return
     */
    network(params) {
        this.save({
            lt: LogType.network,
            ...params
        })
    }
}
